module.exports = __webpack_public_path__ + "img/5fe3d47.png";